<template>
  <div>
    <!-- <v-alert :value="true" type="error" style="height: 40px">
      This page is currently in development and may still contain bugs...
    </v-alert> -->
    <v-alert @click="$store.commit('indexNeededError', false)" dismissible :value="this.$store.getters.indexNeededError" type="error" style="height: 40px">
      Wow! You used a combination of filters that are not indexed yet. We will get them indexed right away. Try your filters again in 30 minutes.
    </v-alert>
    <v-card>
      <v-toolbar v-if="!projectView" flat dark color="cyan" height="50px">
        <v-toolbar-items>
          <v-btn flat @click="currentView = 'gantt'"><v-icon left>calendar_view_day</v-icon>Gantt Chart</v-btn>
          <v-btn flat @click="currentView = 'calendar'"><v-icon left>calendar_today</v-icon>Calendar</v-btn>
          <v-btn flat @click="openCreateTaskDialog"><v-icon left>list_alt</v-icon>Create New Task</v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <span v-if="taskFilters && taskFilters.showOnlyMyTasks">Currently showing only your assigned tasks</span>
        <v-toolbar-items>
          <v-btn class="primary" v-if="!projectView" @click="showFilters = true"><v-icon left>{{isFilterActive ? 'done_all' : 'filter_list'}}</v-icon>Filter Results</v-btn>
          <v-btn class="orange" v-if="!projectView" @click="refreshData"><v-icon left>cached</v-icon>Refresh Data</v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-card>
    <div>
      <!-- Calendar Component -->
      <ejs-schedule v-if="currentView === 'calendar'" id='Schedule' height='650px' 
        :selectedDate='selectedDate' currentView='Week' 
        :eventSettings='calendarData' 
        :timeScale='{ enable: false }' 
        :eventRendered='onEventRendered' 
        :popupOpen='openTask' 
        :actionBegin='onActionBegin' 
        :actionComplete='onActionComplete'
        :allowDragAndDrop="true"
        :rowAutoHeight='true'>
         <e-views>
            <e-view option='Week' displayName='Timeline View'></e-view>
            <e-view option='Month' displayName='Month View'></e-view>
        </e-views>
      </ejs-schedule>
      <!-- End: Calendar Component -->
      <!-- Gantt Component -->
 <ejs-gantt v-if="currentView === 'gantt'" id="GanttContainer" ref='gantt' height='650px' 
        :dataSource="ganttData"
        :includeWeekend="true"
        :taskFields="ganttTaskFields"
        :columns ="ganttColumns"
        :splitterSettings="ganttSplitterSettings"
        :labelSettings="ganttLabelSettings"
        :enableVirtualization="projectView ? false : true"
        :toolbar="ganttToolbar"
        :toolbarClick="ganttToolbarCustomItems"
        :collapseAllParentTasks="false"
        :timelineSettings="ganttTimelineSettings"
        :tooltipSettings="ganttTooltipSettings"
        :actionBegin="ganttOpenTaskDialog"
        :editSettings="ganttEditSettings"
        :allowSelection="true"
        :gridLines="'Both'"
        :cellSelecting="ganttCellSelecting" 
        :selectionSettings="ganttSelectionSettings"
        :queryTaskbarInfo ="ganttQueryTaskbarInfo">
      </ejs-gantt>
      <!-- End: Gantt Component -->
    </div>
  <!-- Task Dialog Box -->
  <v-dialog v-if="editTaskDialog" v-model="editTaskDialog" width="800px" content-class="white">
    <edit-task @addNote="addNote" @closeTaskDialog="editTaskDialog = false" @completeTask="completeTask" @changeTaskStatus="changeTaskStatus" :taskId="selectedTask.id" :project="project" :projectGrid="true" :projectNotes="projectNotes" />
  </v-dialog>
  <!-- End: Task Dialog Box -->
  <!-- Filter Dialog Box -->
  <v-dialog v-if="showFilters" v-model="showFilters" width="800px" persistent>
    <filter-dialog @cancel-dialog="showFilters = false" @execute-filters="refreshData" :currentView="'scheduler'"></filter-dialog>
  </v-dialog>
  <!-- End Filter Dialog Box -->
  <!-- Create Task Dialog -->
  <v-dialog max-width="800px" persistent v-model="createTaskDialog" v-if="createTaskDialog">
    <create-task @closeDialog="createTaskDialog = false" />
  </v-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import FilterDialog from '../dialogs/FilterDialog.vue'
import { SchedulePlugin, Week, Month, DragAndDrop } from '@syncfusion/ej2-vue-schedule'
import { GanttPlugin, Edit, Sort, Filter, Toolbar, VirtualScroll, Selection } from '@syncfusion/ej2-vue-gantt'
import { colorArray } from '../../helpers/helperObjects'
import EditTask from '../tasks/EditTask'
import CreateTask from '../tasks/CreateTask'
import _ from 'lodash'
Vue.use(SchedulePlugin)
Vue.use(GanttPlugin)

export default {
  props: ['projectView'],
  provide: {
    schedule: [Week, Month, DragAndDrop],
    gantt: [ Edit, Sort, Filter, Toolbar, VirtualScroll, Selection ]
  },
  created () {
    if (!this.projectView || this.$store.getters.filteredTasks.length === 0 || this.$store.getters.currentView !== 'scheduler') {
      this.$store.commit('currentView', 'scheduler')
      this.refreshData()
    }
    this.$store.dispatch('getAllDoubleBookedVendors')
  },
  mounted () {
    this.$store.commit('currentView', 'scheduler')
  },
  data () {
    return {
      createTaskDialog: false,
      showAssignedTasksHeader: true,
      showFilters: false,
      currentView: 'gantt', // [calendar, gantt]
      editTaskDialog: false,
      selectedTask: null,
      selectedProject: null,
      selectedProjectTasks: null,
      colorCategory: 'status', // TaskName = name, projectName, status
      colorArray: colorArray,
      selectedDate: new Date(),
      ganttTimelineSettings: { updateTimescaleView: false, timelineUnitSize: 80, topTier: { unit: 'Year' }, bottomTier: { unit: 'Month', format: 'MMM' } },
      ganttTaskFields: {
        id: 'taskId',
        startDate: 'start_date',
        name: 'name',
        endDate: 'due_date',
        duration: 'duration',
        // progress: 'progress',
        child: 'tasks',
        dependency: 'predecessor'
      },
      ganttColumns: [ { field: 'taskId', width: '0', visible: false }, { field: 'name', width: '60' }, { field: 'start_date', width: '20' }, { field: 'due_date', width: '20' }, { field: 'Predecessor', allowEditing: false, width: '0', visible: false } ],
      // ganttSortSettings: { columns: [{ field: 'EndDate', direction: 'Ascending' }, { field: 'TaskName', direction: 'Ascending' }] },
      ganttSplitterSettings: { columnIndex: 4 },
      ganttToolbar: this.projectView ? ['ZoomToFit', { text: 'Week View', tooltipText: 'Week View', id: 'Week' }, { text: 'Month View', tooltipText: 'Month View', id: 'Month' }, { text: 'Year View', tooltipText: 'Year View', id: 'Year' }]
                                     : ['ExpandAll', 'CollapseAll', 'ZoomToFit', { text: 'Week View', tooltipText: 'Week View', id: 'Week' }, { text: 'Month View', tooltipText: 'Month View', id: 'Month' }, { text: 'Year View', tooltipText: 'Year View', id: 'Year' }],
      ganttTooltipSettings: { showTooltip: true, taskbar: function () { return { template: Vue.component('taskbarTemplate', { template: `<div><div>Name: {{data.name}}</div></div>` }) } } },
      ganttLabelSettings: { rightLabel: 'name' },
      ganttEditSettings: { allowEditing: true, allowTaskbarEditing: true, mode: 'Dialog' },
      ganttSelectionSettings: { mode: 'Cell' },
      ganttQueryTaskbarInfo: function (args) {
        if (args.taskbarType !== 'ParentTask') {
          args.taskbarType = 'ChildTask'
          args.taskbarBgColor = args.data.taskData.CategoryColor
        }
      }
    }
  },
  computed: {
    isFilterActive () {
      const defaultFilters = this.$store.getters.defaultFilters.scheduler
      const currentFilters = this.$store.getters.taskFilters.scheduler
      return !_.isEqual(defaultFilters, currentFilters)
    },
    project () {
      return { id: this.selectedProject.id, name: this.selectedProject.name, status: this.selectedProject.status, job_number: this.selectedProject.job_number, start_date: this.selectedProject.start_date }
    },
    taskFilters () {
      return this.$store.getters.taskFilters.scheduler
    },
    ganttData () {
      let filteredTasks = null
      if (this.projectView) {
        let tasks = []
        let taskKeys = Object.keys(this.projectView.tasks)
        taskKeys.forEach(key => {
          let task = { ...this.projectView.tasks[key], id: key, taskId: key, projectId: this.projectView.id }
          if (task.due_date && task.due_date.seconds) task.due_date = new Date(task.due_date.seconds * 1000)
          if (task.start_date && task.start_date.seconds) task.start_date = new Date(task.start_date.seconds * 1000)
          if (task.completed_date && task.completed_date.seconds) task.completed_date = new Date(task.completed_date.seconds * 1000)
          tasks.push(task)
        })
        const projectStartDate = this.projectView.start_date.seconds ? new Date(this.projectView.start_date.seconds * 1000) : this.projectView.start_date
        filteredTasks = [{ ...this.projectView, start_date: projectStartDate, tasks: tasks }]
      } else {
        filteredTasks = this.$store.getters.filteredTasks
      }
      if (filteredTasks && filteredTasks.length > 0) {
        let projects = []
        let allTasks = []
        // Pull Tasks Out and Pass Tasks Through Colorization Pass
        filteredTasks.forEach(project => {
          project.tasks.forEach(task => {
            // Fix if task has no start_date
            // Task Dependencies Require that hyphens be removed
            let newTask = { ...task, taskId: task.id.replace('-', '') }
            if (!task.start_date) {
              newTask = { ...newTask, start_date: project.start_date }
            }
            if (task.after_task) {
              newTask = { ...newTask, predecessor: task.after_task.replace('-', '') + 'FS' }
            }
            allTasks.push(newTask)
          })
        })
        let colorizedTasks = this.taskColorization(allTasks)
        // Group Colorized Tasks Back to Parent Projects
        colorizedTasks = _.orderBy(colorizedTasks, ['start_date', 'due_date'], ['asc', 'asc'])
        colorizedTasks = _.groupBy(colorizedTasks, 'projectId')
        filteredTasks.forEach((project, index) => { projects.push({ ...project, taskId: project.id, tasks: colorizedTasks[project.id] }) })
        projects = _.orderBy(projects, ['start_date', 'due_date'], ['asc', 'asc'])
        return projects
      } else {
        return null
      }
    },
    calendarData () {
      // ##### Get Tasks From Store #####
      let filteredTasks = this.$store.getters.filteredTasks
      let allTasks = []
      filteredTasks.forEach(project => {
        project.tasks.forEach(task => {
          let newTask = { ...task, taskId: task.id.replace('-', ''), projectName: project.name }
          if (!task.start_date) {
            newTask = { ...newTask, start_date: project.start_date, projectName: project.name }
          }
          allTasks.push(newTask)
        })
      })
      let colorizedTasks = this.taskColorization(allTasks)
      // Group Colorized Tasks Back to Parent Projects
      colorizedTasks = _.orderBy(colorizedTasks, ['start_date', 'due_date'], ['asc', 'asc'])
      // Pass Tasks Through Colorization Pass
      // const colorizedTasks = this.taskColorization(filteredTasks)
      let calendarTasks = []
      colorizedTasks.forEach(task => {
        calendarTasks.push({ Id: task.id, Subject: task.name, Location: task.projectName, StartTime: task.due_date, EndTime: task.due_date, IsAllDay: true, CategoryColor: task.CategoryColor, textColor: task.textColor, projectId: task.projectId })
      })
      return { dataSource: calendarTasks }
    },
    projectNotes () {
      const getNotes = this.$store.getters.projectNotes
      const users = this.$store.getters.userList.concat(this.$store.getters.inactiveUsers)
      let notes = []
      getNotes.forEach(note => {
        const user = users.filter(f => f.id === note.created_by)
        notes.push({...note, avatar: user[0].avatar, userFullName: user[0].first_name + ' ' + user[0].last_name})
      })
      return _.orderBy(notes, 'created_date', ['desc'])
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    ganttCellSelecting: function (args) { // Direct to Project
      args.cancel = true
      if (args.data.level === 0) {
        this.$router.push('/project/' + args.data.taskData.id)
      }
      if (args.data.level > 0) {
        this.ganttOpenTaskDialog(args)
      }
    },
    openCreateTaskDialog () {
      this.$store.commit('getProject', null)
      this.createTaskDialog = true
    },
    ganttOpenTaskDialog (args) {
      // If drag and drop event
      if (args.requestType === 'beforeSave') {
        // args.cancel = true
        let task = args.data.taskData
        if (args.data.level === 0) {
          args.cancel = true
          alert('Moving an entire project is not possible. Please select individual tasks.')
          return false
        }
        if (confirm('Moving these tasks will also move ALL unshown dependencies of these tasks as well. ')) {
          this.$store.dispatch('moveSchedulerDates', task)
        }
      }
      // If open task box event
      if (args.requestType === 'beforeOpenEditDialog') {
        args.cancel = true
        if (args.rowData.level !== 0) {
          args.ganttTask = args.rowData.taskData
          this.openTask(args)
        }
      }
      if (args.name === 'cellSelecting') {
        args.cancel = true
        args.ganttTask = args.data.taskData
        this.openTask(args)
      }
    },
    showOnlyMyTasksHeader (dataValues) { // Emits from Filter Dialog Child to Control Header Text
      this.showAssignedTasksHeader = dataValues
    },
    closeFiltersDialog () {
      this.showFilters = false
    },
    refreshData () {
      this.showFilters = false
      this.$store.dispatch('clearFilteredTasks')
      this.$store.dispatch('getFilteredTasks')
    },
    taskColorization (filteredTasks) {
      // ##### Get Groups for Colorization - Duplicates Color Array if enough colors are not available
      let groups = _.uniq(filteredTasks.map(x => x[this.colorCategory]))
      const fitColors = Math.ceil(groups.length / this.colorArray.length) - 1
      let colorTypes = []
      this.colorArray.forEach(color => {
        let textColor = '#fff'
        // Looks to see if the contrast of the selected color needs black or white text according to intensity
        if ((color.rgb[0] * 0.299 + color.rgb[1] * 0.587 + color.rgb[2] * 0.114) > 186) {
          textColor = '#000'
        }
        colorTypes.push({ color: '#' + color.hex, textColor })
      })
      let colorList = colorTypes
      for (let i = 0; i < fitColors; i++) {
        colorList = colorList.concat(colorTypes)
      }

      // ##### Join Groups to Colors
      let colorCategories = []
      if (this.colorCategory === 'status') {
        colorCategories = [
        { type: 'Not Started', color: { color: '#9e9e9e', textColor: '#fff' } },
        { type: 'Started', color: { color: '#006064', textColor: '#fff' } },
        { type: 'On Hold', color: { color: '#fe9700', textColor: '#fff' } },
        { type: 'Flagged', color: { color: '#E91E63', textColor: '#fff' } },
        { type: 'Completed', color: { color: '#4CAF50', textColor: '#fff' } } ]
      } else {
        groups.forEach((g, i) => {
          colorCategories.push({ type: g, color: colorList[i] })
        })
      }

      let tasksColorizations = []
      filteredTasks.forEach(task => {
        colorCategories.forEach(colorSelection => {
          if (task[this.colorCategory] === colorSelection.type) {
            tasksColorizations.push({ ...task, CategoryColor: colorSelection.color.color, textColor: colorSelection.color.textColor })
          }
        })
      })
      return tasksColorizations
    },
    ganttToolbarCustomItems (args) {
      if (args.item.id === 'Week') {
        this.ganttTimelineSettings = { timelineUnitSize: 80, topTier: { unit: 'Week' }, bottomTier: { unit: 'Day', format: null } }
      } else if (args.item.id === 'Month') {
        this.ganttTimelineSettings = { timelineUnitSize: 20, topTier: { unit: 'Month' }, bottomTier: { unit: 'Day', format: null } }
      } else if (args.item.id === 'Year') {
        this.ganttTimelineSettings = { timelineUnitSize: 50, topTier: { unit: 'Year' }, bottomTier: { unit: 'Month', format: 'MMM' } }
      }
    },
    onActionBegin: function (args) {
      // If a task is moved
      if (args.requestType === 'eventChange') {
        if (confirm('Moving these tasks will also move ALL unshown dependencies of these tasks as well. ')) {
          // Get Existing Start Date - Do Not Change Start Date
          let taskList = []
          this.$store.getters.filteredTasks.forEach(project => { project.tasks.forEach(task => { taskList.push(task) }) })
          const payload = { id: args.data.Id, start_date: args.data.StartTime, due_date: args.data.EndTime, projectId: args.data.projectId }
          this.$store.dispatch('moveSchedulerDates', payload)
        } else {
          args.cancel = true
        }
      }
      if (args.requestType === 'toolbarItemRendering') {
        let userIconItem = {
          align: 'Right', text: '↻', cssClass: 'e-schedule-user-icon'
        }
        args.items.push(userIconItem)
      }
    },
    onActionComplete: function (args) {
      let scheduleElement = document.getElementById('Schedule')
      if (args.requestType === 'toolBarItemRendered') {
        let userIconEle = scheduleElement.querySelector('.e-schedule-user-icon')
        userIconEle.onclick = () => {
          this.refreshData()
        }
      }
    },
    onEventRendered: function (args) {
      let categoryColor = args.data.CategoryColor
      let textColor = args.data.textColor
      if (!args.element || !categoryColor || !textColor) {
        return
      }
      if (this.currentView === 'Month') {
        args.element.firstChild.style.borderLeftColor = categoryColor
        args.element.firstChild.style.color = textColor
        if (textColor !== '#fff') {
          args.element.style.setProperty('--text-color', textColor)
        } else {
          args.element.style.setProperty('--text-color', 'white')
        }
      } else {
        args.element.style.backgroundColor = categoryColor
        args.element.style.color = textColor
        if (textColor !== '#fff') {
          args.element.style.setProperty('--text-color', textColor)
        } else {
          args.element.style.setProperty('--text-color', 'white')
        }
      }
    },
    openTask (args) {
      let projectIndex = null
      let taskIndex = null
      if (args.ganttTask) {
        projectIndex = this.$store.getters.filteredTasks.findIndex(i => i.id === args.ganttTask.projectId)
        taskIndex = this.$store.getters.filteredTasks[projectIndex].tasks.findIndex(i => i.id === args.ganttTask.id)
      } else {
        projectIndex = this.$store.getters.filteredTasks.findIndex(i => i.id === args.data.projectId)
        taskIndex = this.$store.getters.filteredTasks[projectIndex].tasks.findIndex(i => i.id === args.data.Id)
      }
      this.selectedTask = Object.assign({}, this.$store.getters.filteredTasks[projectIndex].tasks[taskIndex])
      this.selectedProject = this.$store.getters.filteredTasks.filter(f => f.id === this.selectedTask.projectId)[0]
      // Adjust dates to seconds for edit tasks
      this.selectedTask.due_date = { seconds: Math.round(this.selectedTask.due_date.getTime() / 1000) }
      this.selectedTask.start_date = { seconds: this.selectedTask.start_date ? Math.round(this.selectedTask.start_date.getTime() / 1000) : Math.round(this.selectedProject.start_date.getTime() / 1000) }
      // Get After Task Name
      if (this.selectedTask.dependency) {
        const afterTask = this.$store.getters.filteredTasks.filter(f => f.id === this.selectedTask.dependency)[0]
        if (afterTask) {
          this.selectedTask.dependency = afterTask.name
        }
      }
      // Get Project Tasks
      const gettingProject = this.$store.getters.filteredTasks.filter(f => f.id === this.selectedTask.projectId)[0]
      this.selectedProjectTasks = gettingProject.tasks
      // this.selectedTask.projectId
      this.$store.dispatch('getProject', this.selectedTask.projectId)
      this.$store.dispatch('getProjectNotes', this.selectedTask.projectId)
      this.$store.dispatch('getProjectTasks', [[this.selectedTask.id]])
      // this.$store.dispatch('getProjectTask', {projectId: this.selectedTask.projectId, taskName: this.selectedTask.name})
      this.editTaskDialog = true
      args.cancel = true
    },
    changeTaskStatus (payload) {
      this.selectedTask.status = payload.status
    },
    completeTask (payload) {
      const projectIndex = this.tableData.findIndex(i => i.project === payload.projectName)
      this.tableData[projectIndex][payload.name] = 'Completed'
    },
    addNote (task) {
      const note = task.note ? task.note : this.newNote
      if (note) {
        let payload = {project_id: this.project.id, note: note, project_name: this.project.name, task_id: task.task_id, task_name: task.task_name}
        this.$store.dispatch('addProjectNote', payload)
        this.newNote = null
        this.showNoteForm = false
      }
    }
  },
  components: {
    EditTask, FilterDialog, CreateTask
  }
}
</script>

<style>
@import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-vue-schedule/styles/material.css';
/* Additional for Gantt */
@import '../../../node_modules/@syncfusion/ej2-lists/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-layouts/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-grids/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-richtexteditor/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-treegrid/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-vue-gantt/styles/material.css';
.e-quick-popup-wrapper .e-event-popup .e-popup-header .e-header-icon-wrapper .e-delete {
  display: none;
}
.e-schedule .e-vertical-view.e-timescale-disable .e-appointment .e-time {
  display: none;
}
.e-left-connectorpoint-outer-div, 
.e-right-connectorpoint-outer-div { 
  display: none !important; 
} 

</style>



// WEBPACK FOOTER //
// src/components/scheduling/Scheduler.vue